import { render, staticRenderFns } from "./NewPluginCard.vue?vue&type=template&id=c2b023f0&scoped=true"
import script from "./NewPluginCard.vue?vue&type=script&lang=js"
export * from "./NewPluginCard.vue?vue&type=script&lang=js"
import style0 from "./NewPluginCard.vue?vue&type=style&index=0&id=c2b023f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b023f0",
  null
  
)

export default component.exports